import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import { db, storage } from '../../../../../../../../firebase';
import { useDispatch, useSelector } from 'react-redux';
import { ref } from 'firebase/storage';
import { closeAddItemPhotosDialog } from './item-photos-add-slice';
import { addPhotosService, getItemsDataService } from './item-photos-add-service';
import { showErrorSnackbar, showWarningSnackbar } from '../../../../../../../shared/snackbar/snackbar-slice';

const useStyles = makeStyles((theme) => ({
  // modal: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  // },
  // paper: {
  //   backgroundColor: theme.palette.background.paper,
  //   boxShadow: theme.shadows[5],
  //   padding: theme.spacing(2, 4, 3),
  // },
  button: {
    background: "#111111",
    color: "#fbbbd3",
    '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
  },
  buttonText: {
    color: "#111111",
    '&:hover': {
      backgroundColor: '#fbbbd3',
      color: '#111111',
    },
  },
  title: {
      background:"#111111",
  },
  text: {
      color: "#111111",
  },
}));

const ItemPhotosAdd = (props) => {
  const classes = useStyles();
  const item_id = props.item_id;
  const formData = useSelector((state) => state.itemPhotosAddSlice.itemPhotosAdd);
  const showDialog = useSelector((state) => state.itemPhotosAddSlice.showDialog);
  const isLoading = useSelector((state) => state.itemPhotosAddSlice.isLoading);
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showDialog) {
      const fetchData = async () => {
        try {
          await getItemsDataService(dispatch, db, "items", item_id);
        } catch(e) {
          dispatch(showErrorSnackbar('Something went wrong when fetching.'));
          console.error("ItemPhotosAdd fetchData error: ", e);
        }
      };
    fetchData();
    }
  }, [showDialog, dispatch, item_id]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    } else {
      dispatch(showWarningSnackbar('Please select a file.'));
    }
  };

  const handleUpload = async () => {
    if (file) {
      const timestamp = Date.now();
      const uniqueFileName = `${timestamp}_${file.name}`;
      const storageRef = ref(storage, `/images/${uniqueFileName}`);
      await addPhotosService(dispatch, db, "items", item_id, formData, storageRef, file);
      setFile(null);
      handleClose();
    } else {
      dispatch(showWarningSnackbar('Please select a file.'));
    }
  };
  

  const handleClose = () => {
    dispatch(closeAddItemPhotosDialog());
  }

  return (
    <Dialog
      open={showDialog}
    >
      <DialogTitle className={classes.title}>
        Add Photo
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.text}>
          Select a photo to upload
        </Typography>
        <input type="file" onChange={handleFileChange} />
      </DialogContent>
      <DialogActions>
        <Button
            variant="contained"
            className={classes.button}
            onClick={handleUpload}
            disabled={isLoading}
          >
            {
              isLoading === true ? (
                "Uploading..."
              ) : (
                "Upload"
              )
            }
          </Button>
          <Button
            variant="text"
            className={classes.buttonText}
            onClick={handleClose}
            disabled={isLoading}
          >
              Cancel
          </Button>
      </DialogActions>
    </Dialog>
  )

  // return (
  //   <Modal
  //     open={showDialog}
  //     // onClose={onClose}
  //     className={classes.modal}
  //     aria-labelledby="add-photo-modal-title"
  //     aria-describedby="add-photo-modal-description"
  //   >
  //     <div className={classes.paper}>
  //       <h2 id="add-photo-modal-title">Add Photo</h2>
  //       <p id="add-photo-modal-description">Select a photo to upload:</p>
  //       <input type="file" onChange={handleFileChange} />
  //       {error && <p>{error}</p>}
  //       <Button
  //         variant="contained"
  //         color="primary"
  //         onClick={handleUpload}
  //         disabled={isLoading}
  //       >
  //         {
  //           isLoading === true ? (
  //             "Uploading..."
  //           ) : (
  //             "Upload"
  //           )
  //         }
  //       </Button>
  //     </div>
  //   </Modal>
  // );
};

export default ItemPhotosAdd;
